// @ts-nocheck
import { formatMoney as shopifyFormatMoney } from '@theme/money-formatting';

const WISHLIST_KEY = 'theme_wishlist_handles_v1';
const CUSTOMER_WISHLIST_KEY_PREFIX = 'theme_wishlist_customer_';
const eventName = 'wishlist:updated';
const SWATCH_OPTION_NAMES = [
  'color', 'colour', 'colori', 'colore', 'cor', 'cores', 'culoare', 'boja', 'barva',
  'farbe', 'farben', 'kleur', 'färg', 'farge', 'farve', 'väri',
  'kolor', 'kolory', 'farba', 'цвет', 'цвят',
  'spalva', 'renk', 'χρώμα',
  'สี', 'màu', 'màu sắc', '色', 'カラー', '색상', '색', '顏色', '色彩', '颜色',
  'material', 'materiale', 'materiál', 'materijal', 'materiaali', 'materiał', 'материал',
  'medžiaga', 'malzeme', 'materiaal', 'anyag', 'bahan', 'chất liệu', '소재', '材質', '材质',
  'วัสดุ', '素材',
  'metal', 'metall', 'metalne', 'μέταλλο', 'метал', '금속', '金属', 'โลหะ',
  'finish', 'finisare', 'afwerking', 'viimeistely', 'dopracowanie', 'отделка', 'apdirbimas', 'bitiş',
  '마무리', '仕上げ', 'ตกแต่ง', '完成'
];
const SWATCH_COLOR_MAP = {
  // 1. Custom Druzy stone swatches (diagonal split gradients with cream) - check first
  'dark brown': 'linear-gradient(135deg, #4a3319 50%, #f5f2eb 50%)',
  'brown': 'linear-gradient(135deg, #7c5c43 50%, #f5f2eb 50%)',
  'grey': 'linear-gradient(135deg, #888888 50%, #f5f2eb 50%)',
  'gray': 'linear-gradient(135deg, #888888 50%, #f5f2eb 50%)',
  'champagne': 'linear-gradient(135deg, #d3bca6 50%, #f5f2eb 50%)',
  'olive': 'linear-gradient(135deg, #747d63 50%, #f5f2eb 50%)',
  'indigo': 'linear-gradient(135deg, #2b3a4a 50%, #f5f2eb 50%)',
  'azure': 'linear-gradient(135deg, #007fff 50%, #f5f2eb 50%)',
  'blue': 'linear-gradient(135deg, #007fff 50%, #f5f2eb 50%)',
  'green': 'linear-gradient(135deg, #747d63 50%, #f5f2eb 50%)',
  'red': 'linear-gradient(135deg, #a83c3c 50%, #f5f2eb 50%)',

  // 2. Specific metals & colors
  'gold vermeil': '#e8d9a8',
  'white gold': '#ece8df',
  'sterling silver': '#c8c8c8',
  'rose gold': '#e8b4a2',

  // 3. Generic metals & colors
  gold: '#e8d9a8',
  yellow: '#e8d9a8',
  silver: '#c8c8c8',
  rose: '#e8b4a2',
  platinum: '#d9d9d9',
  white: '#f5f5f5',
  black: '#2b2b2b',
};

const normalizeHandle = (value) => String(value || '').trim().toLowerCase();

const normalizeArray = (items) => {
  if (!Array.isArray(items)) return [];
  const seen = new Set();
  const normalized = [];
  for (const item of items) {
    const handle = normalizeHandle(item);
    if (!handle || seen.has(handle)) continue;
    seen.add(handle);
    normalized.push(handle);
  }
  return normalized;
};

const readLocalWishlist = (key = WISHLIST_KEY) => {
  try {
    const parsed = JSON.parse(localStorage.getItem(key) || '[]');
    return normalizeArray(parsed);
  } catch (error) {
    return [];
  }
};

const writeLocalWishlist = (handles, key = WISHLIST_KEY) => {
  localStorage.setItem(key, JSON.stringify(normalizeArray(handles)));
};

const resolveMetafieldHandles = (metafieldValue) => {
  if (Array.isArray(metafieldValue)) return normalizeArray(metafieldValue);
  if (typeof metafieldValue === 'string' && metafieldValue.trim().length > 0) {
    try {
      return normalizeArray(JSON.parse(metafieldValue));
    } catch (error) {
      return [];
    }
  }
  return [];
};

class Wishlist {
  constructor() {
    const themeObject = window.Theme && typeof window.Theme === 'object' ? window.Theme : {};
    this.config = themeObject.wishlist || {};
    this.loggedIn = Boolean(this.config.customerLoggedIn);
    this.syncEndpoint = this.config.syncEndpoint || '/apps/wishlist/sync';
    this.pageUrl = this.config.pageUrl || '/pages/wishlist';
    this.customerId = this.config.customerId ? String(this.config.customerId) : null;
    this.customerStorageKey = this.customerId
      ? `${CUSTOMER_WISHLIST_KEY_PREFIX}${this.customerId}`
      : null;
    this.handles = [];
    this.onClick = this.onClick.bind(this);
    this.onWishlistActionsClick = this.onWishlistActionsClick.bind(this);
    this.onDomMutations = this.onDomMutations.bind(this);
    this.bound = false;
    this.observer = null;
    this.renderQueued = false;
    this.productCache = new Map();
  }

  init() {
    const metafieldHandles = resolveMetafieldHandles(this.config.metafieldWishlist);

    if (this.loggedIn && this.customerId) {
      // 1. Customer ka apna personal local data
      const customerSpecificHandles = readLocalWishlist(this.customerStorageKey);

      // 2. Guest ka data (agar login karne se pehle usne kuch add kiya tha)
      const guestHandles = readLocalWishlist(WISHLIST_KEY);

      // 3. Teeno ko ek saath mila do (Metafield + Customer Local + Guest Local)
      const combinedHandles = [...metafieldHandles, ...customerSpecificHandles, ...guestHandles];
      this.handles = normalizeArray(combinedHandles);

      // 4. Guest storage ko localStorage se delete kar do, taki logout pe 0 ho jaye
      localStorage.removeItem(WISHLIST_KEY);

      this.persistLocal();

      // Agar guest items the, toh ek bar backend par sync hit kar do
      if (guestHandles.length > 0) {
        this.syncMetafield('add', guestHandles[0], null).catch(() => { });
      }

    } else {
      // Agar logout hai ya guest hai, toh generic guest wishlist dikhao
      this.handles = readLocalWishlist();
    }

    this.bindEvents();
    this.renderAll();
    this.observeDomUpdates();
    this.renderWishlistPage();
  }

  persistLocal() {
    if (this.loggedIn && this.customerStorageKey) {
      // Logged-in user ka data sirf uski specific key mein save hoga
      writeLocalWishlist(this.handles, this.customerStorageKey);
    } else {
      // Guest user ka data generic key mein save hoga
      writeLocalWishlist(this.handles, WISHLIST_KEY);
    }
  }

  bindEvents() {
    if (this.bound) return;
    this.bound = true;
    document.addEventListener('click', this.onClick, true);
    document.addEventListener('click', this.onWishlistActionsClick);
  }

  observeDomUpdates() {
    if (this.observer) return;
    this.observer = new MutationObserver(this.onDomMutations);
    this.observer.observe(document.body, { childList: true, subtree: true });
  }

  onDomMutations(mutations) {
    let hasRelevantChange = false;
    for (const mutation of mutations) {
      if (mutation.type !== 'childList' || mutation.addedNodes.length === 0) continue;
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches?.('[data-wishlist-toggle]') || node.querySelector?.('[data-wishlist-toggle]')) {
          hasRelevantChange = true;
          break;
        }
      }
      if (hasRelevantChange) break;
    }

    if (!hasRelevantChange || this.renderQueued) return;

    this.renderQueued = true;
    window.requestAnimationFrame(() => {
      this.renderQueued = false;
      this.renderButtons();
      this.updateCounter();
    });
  }

  onClick(event) {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-wishlist-toggle]');
    if (!(button instanceof HTMLButtonElement)) return;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    const handle = normalizeHandle(button.dataset.productHandle);
    const productId = String(button.dataset.productId || '');
    if (!handle) return;

    const isActive = this.handles.includes(handle);
    if (isActive) {
      this.handles = this.handles.filter((item) => item !== handle);
    } else {
      this.handles = normalizeArray([...this.handles, handle]);
    }

    this.persistLocal();
    this.animateButton(button);
    this.renderAll();
    this.dispatchUpdate();

    if (this.loggedIn) {
      this.syncMetafield(isActive ? 'remove' : 'add', handle, productId).catch(() => { });
    }
  }

  onWishlistActionsClick(event) {
    if (!(event.target instanceof Element)) return;

    const swatchButton = event.target.closest('[data-wishlist-swatch]');
    if (swatchButton instanceof HTMLButtonElement) {
      event.preventDefault();
      this.selectWishlistSwatch(swatchButton);
      return;
    }

    const removeButton = event.target.closest('[data-wishlist-remove]');
    if (removeButton instanceof HTMLButtonElement) {
      event.preventDefault();
      const handle = normalizeHandle(removeButton.dataset.productHandle);
      this.removeHandle(handle);
      this.renderWishlistPage();
      return;
    }

    const addToCartButton = event.target.closest('[data-wishlist-add-to-cart]');
    if (addToCartButton instanceof HTMLButtonElement) {
      event.preventDefault();
      this.addToCart(addToCartButton);
    }
  }

  removeHandle(handle) {
    if (!handle) return;
    this.handles = this.handles.filter((item) => item !== handle);
    this.persistLocal();
    this.renderAll();
    this.dispatchUpdate();
    if (this.loggedIn) {
      this.syncMetafield('remove', handle, null).catch(() => { });
    }
  }

  async addToCart(button) {
    const variantId = String(button.dataset.variantId || '').trim();
    if (!/^\d+$/.test(variantId)) {
      button.textContent = 'Unavailable';
      return;
    }
    button.disabled = true;
    let resetTimeout = 1200;
    let shouldDisablePermanently = false;

    try {
      const themeObject = window.Theme && typeof window.Theme === 'object' ? window.Theme : {};
      const routes = themeObject.routes && typeof themeObject.routes === 'object' ? themeObject.routes : {};
      const cartAddUrl = routes.cart_add_url || '/cart/add.js';

      const cartItemsComponents = document.querySelectorAll('cart-items-component');
      const cartItemComponentsSectionIds = [];
      cartItemsComponents.forEach((item) => {
        if (item instanceof HTMLElement && item.dataset.sectionId) {
          cartItemComponentsSectionIds.push(item.dataset.sectionId);
        }
      });

      const payload = {
        items: [{ id: variantId, quantity: 1 }],
      };
      if (cartItemComponentsSectionIds.length > 0) {
        payload.sections = cartItemComponentsSectionIds.join(',');
      }

      const response = await fetch(`${cartAddUrl}`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        let errorData = null;
        try {
          errorData = await response.json();
        } catch (_) {}
        
        if (response.status === 422 && errorData) {
          const errorMsg = errorData.description || errorData.message || '';
          throw { status: response.status, message: errorMsg, isCartError: true };
        }
        throw new Error(`Cart add failed: ${response.status}`);
      }

      const responseData = await response.json();

      // Fetch updated cart to get the correct total quantity for all items
      const cartResponse = await fetch('/cart.js');
      let cartData = null;
      if (cartResponse.ok) {
        cartData = await cartResponse.json();
      }

      // Dispatch CartAddEvent (as a custom event of name 'cart:update')
      const cartAddEvent = new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cartData || responseData,
          sourceId: button.id || 'wishlist-add-to-cart',
          data: {
            source: 'wishlist',
            itemCount: cartData ? cartData.item_count : 1,
            sections: responseData.sections,
            variantId: variantId,
          },
        },
      });
      document.dispatchEvent(cartAddEvent);

      button.textContent = 'Added to cart';
    } catch (error) {
      console.error(error);
      if (error && error.isCartError) {
        let cartQty = 0;
        try {
          const cartResponse = await fetch('/cart.js');
          if (cartResponse.ok) {
            const cartData = await cartResponse.json();
            const matchingItem = cartData.items?.find((item) => String(item.variant_id) === variantId);
            if (matchingItem) {
              cartQty = matchingItem.quantity;
            }
          }
        } catch (_) {}

        if (cartQty > 0) {
          button.textContent = `Only ${cartQty} items were added to your cart due to availability.`;
          resetTimeout = 5000;
        } else {
          button.textContent = 'Sold out';
          shouldDisablePermanently = true;
        }
      } else {
        button.textContent = 'Try again';
      }
    } finally {
      setTimeout(() => {
        if (shouldDisablePermanently) {
          button.disabled = true;
        } else {
          button.disabled = false;
          button.textContent = 'Add to Cart';
        }
      }, resetTimeout);
    }
  }

  animateButton(button) {
    button.classList.remove('is-animating');
    window.requestAnimationFrame(() => button.classList.add('is-animating'));
    window.setTimeout(() => button.classList.remove('is-animating'), 260);
  }

  dispatchUpdate() {
    document.dispatchEvent(
      new CustomEvent(eventName, {
        detail: { handles: [...this.handles], count: this.handles.length },
      })
    );
  }

  renderAll() {
    this.renderButtons();
    this.updateCounter();
  }

  renderButtons() {
    const buttons = document.querySelectorAll('[data-wishlist-toggle]');
    for (const button of buttons) {
      if (!(button instanceof HTMLButtonElement)) continue;
      const handle = normalizeHandle(button.dataset.productHandle);
      const active = this.handles.includes(handle);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    }
  }

  updateCounter() {
    const counters = document.querySelectorAll('[data-wishlist-count]');
    const count = this.handles.length;

    for (const counter of counters) {
      counter.textContent = String(count);

      // Agar count 0 hai toh element ko hide karein, warna show karein
      if (count === 0) {
        counter.style.display = 'none';
      } else {
        counter.style.display = '';
      }
    }
  }

  async syncMetafield(action, productHandle, productId) {
    if (!this.loggedIn) return;
    await fetch(this.syncEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        namespace: 'custom',
        key: 'wishlist',
        wishlist: this.handles,
        action,
        product_handle: productHandle,
        product_id: productId,
      }),
    });
  }

  formatMoney(cents) {
    const themeObject = window.Theme && typeof window.Theme === 'object' ? window.Theme : {};
    const currency = themeObject.currency || 'USD';
    const showCurrencyCode = (currency.toUpperCase() === 'AUD');

    let format = (showCurrencyCode && themeObject.currencyCodeEnabled ? themeObject.moneyWithCurrencyFormat : themeObject.moneyFormat) || '${{amount}}';
    const shopCurrency = themeObject.shopCurrency || 'USD';

    // Replace shop currency with active currency in format string (case-insensitive)
    const regex = new RegExp(shopCurrency, 'gi');
    if (regex.test(format)) {
      format = format.replace(regex, currency);
    }

    // If currency code is enabled but format still does not include the currency code, append it
    if (showCurrencyCode && themeObject.currencyCodeEnabled && !format.toLowerCase().includes(currency.toLowerCase())) {
      format = `${format} ${currency}`;
    }

    try {
      let formatted = shopifyFormatMoney(cents, format, currency);
      if (!showCurrencyCode) {
        // Strip the currency code from the output if it's not AUD
        const cleanRegex = new RegExp(`\\b${currency}\\b`, 'gi');
        formatted = formatted.replace(cleanRegex, '').trim();
      }
      return formatted;
    } catch (e) {
      const amount = (Number(cents || 0) / 100).toFixed(2);
      return `$${amount}`;
    }
  }

  renderPriceHTML(priceCents, compareAtPriceCents) {
    const enableFakeSale = this.config.enableFakeSale !== false;
    const fakeSalePercentage = Number(this.config.fakeSaleDiscountPercentage) || 25;

    let finalPrice = Number(priceCents || 0);
    let comparePrice = Number(compareAtPriceCents || 0);
    let showCompare = false;
    let discountPct = 0;

    if (finalPrice > 0 && enableFakeSale) {
      const divider = 100 - fakeSalePercentage;
      const compareCents = (finalPrice * 100) / divider;
      const compareDollars = Math.floor(compareCents / 100);
      comparePrice = compareDollars * 100;
      showCompare = true;
      discountPct = fakeSalePercentage;
    } else if (comparePrice > finalPrice) {
      showCompare = true;
      discountPct = Math.round(((comparePrice - finalPrice) / comparePrice) * 100);
    }

    const formattedPrice = this.formatMoney(finalPrice);

    if (showCompare && comparePrice > 0) {
      const formattedCompare = this.formatMoney(comparePrice);
      const badgeMarkup = enableFakeSale || discountPct > 0 ? `
        <span class="price-item__group">
          <span class="discount-badge">${discountPct}% OFF</span>
        </span>
      ` : '';

      return `
        <div class="price__sale">
          <span class="price-item__group">
            <span class="price-item--sale price">${formattedPrice}</span>
          </span>
          <span class="price-item__group">
            <span class="price-item--regular compare-at-price">${formattedCompare}</span>
          </span>
          ${badgeMarkup}
        </div>
      `;
    }

    return `
      <div class="price__regular">
        <span class="price">${formattedPrice}</span>
      </div>
    `;
  }

  getSwatchOption(product) {
    if (!product?.options?.length) return null;
    return (
      product.options.find((option) => {
        const name = typeof option === 'object' && option !== null ? (option.name || '') : option;
        const normalizedName = String(name).trim().toLowerCase();
        return SWATCH_OPTION_NAMES.some((keyword) => normalizedName.includes(keyword));
      }) || null
    );
  }

  getVariantForOptionValue(product, optionName, optionValue) {
    if (!product?.variants?.length) return null;
    const optionIndex = product.options.findIndex((option) => {
      const name = typeof option === 'object' && option !== null ? (option.name || '') : option;
      return String(name).toLowerCase() === String(optionName || '').toLowerCase();
    });
    if (optionIndex < 0) return null;
    const optionKey = `option${optionIndex + 1}`;
    return (
      product.variants.find((variant) => String(variant[optionKey] || '') === String(optionValue || '')) || null
    );
  }

  getSwatchBackground(optionValue, variant) {
    if (variant && variant.swatch_background) {
      return variant.swatch_background;
    }

    const normalizedValue = String(optionValue || '').trim().toLowerCase();
    for (const [name, color] of Object.entries(SWATCH_COLOR_MAP)) {
      if (normalizedValue.includes(name)) {
        return color;
      }
    }

    const variantImage = variant?.featured_image?.src || variant?.featured_image;
    if (variantImage) {
      return `url("${variantImage}")`;
    }

    return '#ddd';
  }

  buildSwatchesMarkup(product, selectedVariant) {
    return '';
  }

  getVariantVideo(product, variant) {
    if (!product?.media?.length || !variant?.featured_image) return null;
    const imageId = variant.featured_image.id;
    const imageUrl = variant.featured_image.src || variant.featured_image;

    const matchingMedia = product.media.find((media) => {
      if (media.media_type !== 'video' && media.media_type !== 'external_video') return false;
      if (media.id === imageId || media.preview_image?.id === imageId) return true;

      const mediaSrc = media.src || media.preview_image?.src || '';
      if (mediaSrc && imageUrl) {
        const cleanUrl = (url) => String(url).split('?')[0].replace(/_(small|medium|large|grande|\d+x\d+)/, '');
        return cleanUrl(mediaSrc) === cleanUrl(imageUrl);
      }
      return false;
    });

    return matchingMedia || null;
  }

  selectWishlistSwatch(button) {
    const card = button.closest('.wishlist-card');
    if (!card) return;

    const variantId = String(button.dataset.variantId || '').trim();
    const mediaLink = card.querySelector('.wishlist-card__image-link');
    const price = card.querySelector('[data-wishlist-price]');
    const addToCartButton = card.querySelector('[data-wishlist-add-to-cart]');
    const product = this.productCache.get(normalizeHandle(button.dataset.productHandle));

    if (!variantId || !product) return;

    const variant = product.variants?.find((item) => String(item.id) === variantId);
    if (!variant) return;

    card.querySelectorAll('[data-wishlist-swatch]').forEach((swatch) => {
      swatch.classList.toggle('is-active', swatch === button);
    });

    if (mediaLink) {
      const videoMedia = this.getVariantVideo(product, variant);
      const mp4Source = videoMedia?.sources?.find((s) => s.mime_type === 'video/mp4' || s.format === 'mp4')?.url;

      if (mp4Source) {
        mediaLink.innerHTML = `
          <video src="${mp4Source}" autoplay loop muted playsinline class="wishlist-card__video" style="width: 100%; height: 100%; object-fit: cover; display: block;"></video>
        `;
      } else {
        const nextImage = variant.featured_image?.src || variant.featured_image || product.featured_image;
        if (nextImage) {
          mediaLink.innerHTML = `
            <img src="${nextImage}" alt="${this.escapeHtml(product.title)}" loading="lazy" style="width: 100%; height: 100%; object-fit: cover; display: block;">
          `;
        }
      }
    }

    if (price) {
      price.innerHTML = this.renderPriceHTML(variant.price, variant.compare_at_price);
    }

    if (addToCartButton instanceof HTMLButtonElement) {
      addToCartButton.dataset.variantId = variantId;
      addToCartButton.disabled = variant.available === false;
      addToCartButton.textContent = variant.available === false ? 'Sold out' : 'Add to Cart';
    }
  }

  buildWishlistCard(product) {
    this.productCache.set(product.handle, product);

    const firstAvailableVariant = product.variants?.find((variant) => variant.available) || product.variants?.[0];
    const selectedVariant = firstAvailableVariant || null;
    const variantId = selectedVariant?.id ? String(selectedVariant.id) : '';
    const canAddToCart = Boolean(variantId) && selectedVariant?.available !== false;
    const image = selectedVariant?.featured_image?.src || selectedVariant?.featured_image || product.featured_image || '';

    // Check if variant has a video
    const videoMedia = this.getVariantVideo(product, selectedVariant);
    const mp4Source = videoMedia?.sources?.find((s) => s.mime_type === 'video/mp4' || s.format === 'mp4')?.url;
    let mediaMarkup = '';

    if (mp4Source) {
      mediaMarkup = `
        <video src="${mp4Source}" autoplay loop muted playsinline class="wishlist-card__video" style="width: 100%; height: 100%; object-fit: cover; display: block;"></video>
      `;
    } else if (image) {
      mediaMarkup = `
        <img src="${image}" alt="${this.escapeHtml(product.title)}" loading="lazy">
      `;
    }

    const price = this.renderPriceHTML(selectedVariant?.price ?? product.price, selectedVariant?.compare_at_price ?? product.compare_at_price);
    const swatchesMarkup = this.buildSwatchesMarkup(product, selectedVariant);

    return `
      <article class="wishlist-card" data-product-handle="${product.handle}">
        <a class="wishlist-card__image-link" href="${product.url}">
          ${mediaMarkup}
        </a>
        <div class="wishlist-card__body">
          <h3 class="wishlist-card__title"><a href="${product.url}">${this.escapeHtml(product.title)}</a></h3>
          <div class="wishlist-card__price" data-wishlist-price>${price}</div>
          ${swatchesMarkup}
        </div>
        <div class="wishlist-card__actions">
          <button type="button" class="wishlist-card__button" data-wishlist-add-to-cart data-variant-id="${variantId}" ${canAddToCart ? '' : 'disabled'}>${canAddToCart ? 'Add to Cart' : 'Sold out'}</button>
          <button type="button" class="wishlist-card__button wishlist-card__button--secondary" data-wishlist-remove data-product-handle="${product.handle}">Remove</button>
        </div>
      </article>
    `;
  }

  async renderWishlistPage() {
    const root = document.querySelector('[data-wishlist-page]');
    if (!root) return;

    if (this.handles.length === 0) {
      this.productCache.clear();
      root.innerHTML = `
        <div class="wishlist-empty">
          <p class="wishlist-empty__text">Your wishlist is empty.</p>
          <a href="/collections/all" class="button wishlist-empty__button">
            <span class="button-text">Continue shopping</span>
          </a>
        </div>
      `;
      return;
    }

    const themeObject = window.Theme && typeof window.Theme === 'object' ? window.Theme : {};
    const rootUrl = themeObject.routes?.root_url || '/';

    const products = await Promise.all(
      this.handles.map(async (handle) => {
        try {
          const fetchUrl = `${rootUrl}/products/${handle}.js`.replace(/\/+/g, '/');
          const response = await fetch(fetchUrl);
          if (!response.ok) return null;
          const product = await response.json();

          try {
            const metafieldsUrl = `${rootUrl}/products/${handle}?view=wishlist-metafields`.replace(/\/+/g, '/');
            const mfResponse = await fetch(metafieldsUrl);
            if (mfResponse.ok) {
              const mfData = await mfResponse.json();
              if (mfData && Array.isArray(mfData.variants)) {
                product.variants = product.variants.map((variant) => {
                  const match = mfData.variants.find((v) => String(v.id) === String(variant.id));
                  if (match && match.swatch_background) {
                    variant.swatch_background = match.swatch_background;
                  }
                  return variant;
                });
              }
            }
          } catch (e) {
            // Metafields fetch failed or template not updated yet
          }

          // Price HTML is now fully generated client-side using renderPriceHTML

          return product;
        } catch (error) {
          return null;
        }
      })
    );

    this.productCache.clear();

    const cards = products.filter(Boolean).map((product) => this.buildWishlistCard(product));

    root.innerHTML = `<div class="wishlist-grid">${cards.join('')}</div>`;
  }

  escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  try {
    window.Theme = window.Theme || {};
    const wishlist = new Wishlist();
    wishlist.init();
    window.Theme.wishlistManager = wishlist;
  } catch (error) {
    console.error('Wishlist initialization failed:', error);
  }
});